import React from "react";
import { useT } from "../../context/LanguageContext";

const T_KEYS = {
  new: "lead.statusNew",
  contacted: "lead.statusContacted",
  quoted: "lead.statusQuoted",
  booked: "lead.statusBooked",
  closed: "lead.statusClosed",
  cancelled: "lead.statusCancelled",
};

export const StatusBadge = ({ status }) => {
  const { t } = useT();
  const s = status || "new";
  const tKey = T_KEYS[s];
  return (
    <span className={`status-badge status-${s}`} data-testid={`status-badge-${s}`}>
      {tKey ? t(tKey) : s}
    </span>
  );
};
